(function () {
  function compactSpaces(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function normalizeTireSize(value) {
    return value.replace(/\b(\d{2,3})(\d{2})(\d{2})\b/g, function (match, width, aspect, rim) {
      var widthNumber = Number(width);
      var aspectNumber = Number(aspect);
      var rimNumber = Number(rim);
      if (widthNumber < 70 || widthNumber > 260) return match;
      if (aspectNumber < 25 || aspectNumber > 100) return match;
      if (rimNumber < 8 || rimNumber > 23) return match;
      return widthNumber + '/' + aspectNumber + ' ' + rimNumber;
    });
  }

  function extractStrongPartNumber(value) {
    var tokens = String(value || '').match(/[a-z0-9][a-z0-9./-]{4,}[a-z0-9]/gi) || [];
    for (var index = 0; index < tokens.length; index += 1) {
      var token = tokens[index].replace(/^[^a-z0-9]+|[^a-z0-9]+$/gi, '');
      var compact = token.replace(/[^a-z0-9]/gi, '').toUpperCase();
      if (isStrongPartNumber(compact)) return token;
    }
    return '';
  }

  function isStrongPartNumber(compact) {
    if (!compact || compact.length < 6) return false;
    if (isCompactTireToken(compact)) return false;
    if (/^(?:IPHONE|GALAXY|PIXEL|SAMSUNG)/i.test(compact)) return false;
    if (isVehicleModelToken(compact)) return false;
    if (/^(?:S|M)\d{3,4}(?:RR|R|XR)?$/i.test(compact)) return false;
    if (/^R\d{3,4}(?:GS|R|RS|RT)?$/i.test(compact)) return false;
    if (/^VSTROM\d{3,4}$/i.test(compact)) return false;
    if (/^\d{6,}$/.test(compact)) return true;
    return /[A-Z]/.test(compact) && /\d/.test(compact);
  }

  function isVehicleModelToken(value) {
    var compact = String(value || '').replace(/[^a-z0-9]/gi, '');
    return /^(?:CRF|CBR|XR|XL|XLR|DR|DRZ|KX|KLX|KLR|YZ|YZF|WR|RMZ|RM|MT|FZ|ZX|NINJA|GSXR?|GSXS|SV|RSV?|TUONO|PANIGALE|STREETFIGHTER|DUKE|RC)\d/i.test(compact);
  }

  function exactPartNumber(value) {
    var source = compactSpaces(value);
    var token = extractStrongPartNumber(source);
    if (!token) return '';
    // Only remove an explicit SKU/MPN label, never the customer's make, model,
    // product/category or other compound-query context.
    var remainder = source.replace(token, '').replace(/^(?:sku|mpn|part\s*(?:number|no\.?|#))\s*[:#-]?\s*/i, '').trim();
    return remainder ? '' : token;
  }

  function isCompactTireToken(compact) {
    var match = String(compact || '').match(/^(\d{2,3})(\d{2})(?:ZR|R|B|V)?(\d{2})$/i);
    if (!match) return false;
    var width = Number(match[1]);
    var aspect = Number(match[2]);
    var rim = Number(match[3]);
    return width >= 70 && width <= 260 && aspect >= 25 && aspect <= 100 && rim >= 8 && rim <= 23;
  }

  function formatPhoneSuffix(value) {
    var suffix = compactSpaces(value || '').toLowerCase();
    if (!suffix) return '';
    if (suffix === 'promax') return 'Pro Max';
    if (suffix === 'pro max') return 'Pro Max';
    if (suffix === 'pro') return 'Pro';
    if (suffix === 'max') return 'Max';
    if (suffix === 'plus' || suffix === '+') return 'Plus';
    if (suffix === 'mini') return 'Mini';
    if (suffix === 'air') return 'Air';
    if (suffix === 'ultra') return 'Ultra';
    if (suffix === 'fe') return 'FE';
    if (suffix === 'e') return 'E';
    if (suffix === 's') return 'S';
    if (suffix === 'c') return 'C';
    if (suffix === 'xl') return 'XL';
    if (suffix === 'pro xl') return 'Pro XL';
    if (suffix === 'a') return 'a';
    return suffix.toUpperCase();
  }

  function normalizePhoneAlias(value) {
    return value
      .replace(/\bi\s*phone\b/gi, 'iPhone')
      .replace(/\biphone\s*(?:se|s\s*e)(?:\s*(?:2|3|2020|2022|2nd\s*gen|3rd\s*gen))?\b/gi, 'iPhone SE')
      .replace(/\biphone\s*(xs\s*max|xsmax|xs|xr|x)\b/gi, function (match, model) {
        var compact = compactSpaces(model).toLowerCase().replace(/\s+/g, '');
        if (compact === 'xsmax') return 'iPhone XS Max';
        if (compact === 'xs') return 'iPhone XS';
        if (compact === 'xr') return 'iPhone XR';
        return 'iPhone X';
      })
      .replace(/\biphone\s*([5-9]|1[0-9])\s*(pro\s*max|promax|pro|plus|\+|mini|air|max|e|s|c)?\b/gi, function (match, model, suffix) {
        var formatted = 'iPhone ' + model;
        var formattedSuffix = formatPhoneSuffix(suffix);
        return formattedSuffix ? formatted + (formattedSuffix === 'E' ? formattedSuffix : ' ' + formattedSuffix) : formatted;
      })
      .replace(/\b(?:samsung\s+)?(?:galaxy\s+)?s\s*(2[0-9])\s*(ultra|plus|\+|fe)?\b/gi, function (match, model, suffix) {
        var formattedSuffix = formatPhoneSuffix(suffix);
        return 'Galaxy S' + model + (formattedSuffix ? ' ' + formattedSuffix : '');
      })
      .replace(/\b(?:samsung\s+)?(?:galaxy\s+)?a\s*(\d{2})\s*(5g)?\b/gi, function (match, model, suffix) {
        return 'Galaxy A' + model + (suffix ? ' 5G' : '');
      })
      .replace(/\b(?:samsung\s+)?(?:galaxy\s+)?z\s*(fold|flip)\s*(\d)\b/gi, function (match, family, model) {
        return 'Galaxy Z ' + family.charAt(0).toUpperCase() + family.slice(1).toLowerCase() + ' ' + model;
      })
      .replace(/\bz(fold|flip)(\d)\b/gi, function (match, family, model) {
        return 'Galaxy Z ' + family.charAt(0).toUpperCase() + family.slice(1).toLowerCase() + ' ' + model;
      })
      .replace(/\b(?:google\s+)?pixel\s*(\d{1,2})\s*(pro\s*xl|pro|xl|a)?\b/gi, function (match, model, suffix) {
        var formattedSuffix = formatPhoneSuffix(suffix);
        return 'Pixel ' + model + (formattedSuffix ? ' ' + formattedSuffix : '');
      });
  }

  function normalizeYamahaRAlias(value) {
    // Consume the whole alias once, including old duplicated prefixes. Do not
    // rewrite R-model fragments embedded in supplier part numbers.
    return value.replace(/(^|[^a-z0-9./-])(?:yzf\s*-?\s*)*r\s*-?\s*(1m?|3|6|7)(?![a-z0-9./-])/gi, function (match, prefix, model) {
      return prefix + 'YZF-R' + model.toUpperCase();
    });
  }

  function normalizeModelAlias(value) {
    return value
      .replace(/\b(?:kawasaki\s+)?(?:ninja\s+)?(?:zx\s*-?\s*6r|zx6r|zx\s*636|zx636)\b/gi, 'Kawasaki ZX-6R')
      .replace(/\bkawasaki\s+636\b/gi, 'Kawasaki ZX-6R')
      .replace(/\b636\b(?=.*\b(?:kawasaki|ninja|zx|fuel|gas|tank|cap|slip|muffler|exhaust)\b)/gi, 'Kawasaki ZX-6R')
      .replace(/\bzx\s*-?\s*(6|10|14)r\b/gi, 'ZX-$1R')
      .replace(/\bzx\s*-?\s*4rr?\b/gi, 'ZX-4R')
      .replace(/\bninja\s*zx\s*-?\s*(4|6|10|14)r\b/gi, 'Ninja ZX-$1R')
      .replace(/\bmt\s*-?\s*(0?3|0?7|0?9|10)\b/gi, function (match, model) {
        return 'MT-' + model.padStart(2, '0');
      })
      .replace(/\bfz\s*-?\s*(0?6|0?7|0?9|10)\b/gi, function (match, model) {
        return 'FZ-' + model.padStart(2, '0');
      })
      .replace(/\bt7\b/gi, 'Tenere 700')
      .replace(/\btenere\s*700\b/gi, 'Tenere 700')
      .replace(/\bcrf\s*-?\s*(150|250|300|450|1100)\s*-?\s*(r|rx|x|l|rl)?\b/gi, function (match, size, suffix) {
        return 'CRF' + size + (suffix || '').toUpperCase();
      })
      .replace(/\bcbr\s*-?\s*(250|300|500|600|650|1000)\s*-?\s*(r|rr)?\b/gi, function (match, size, suffix) {
        return 'CBR' + size + (suffix || '').toUpperCase();
      })
      .replace(/\bafrica\s*twin\b/gi, 'Africa Twin')
      .replace(/(^|[^a-z0-9-])s\s*1000\s*(rr|r|xr)?\b/gi, function (match, prefix, suffix) {
        return prefix + 'S1000' + (suffix || '').toUpperCase();
      })
      .replace(/(^|[^a-z0-9-])m\s*1000\s*(rr|r|xr)?\b/gi, function (match, prefix, suffix) {
        return prefix + 'M1000' + (suffix || '').toUpperCase();
      })
      .replace(/(^|[^a-z0-9-])r\s*(1200|1250|1300)\s*(gs|r|rs|rt)?\b/gi, function (match, prefix, size, suffix) {
        return prefix + 'R' + size + (suffix || '').toUpperCase();
      })
      .replace(/\bgsx\s*-?\s*r\s*-?\s*(600|750|1000|1300)\b/gi, 'GSX-R $1')
      .replace(/\bgsxr\s*(600|750|1000|1300)\b/gi, 'GSX-R $1')
      .replace(/\bgsx\s*-?\s*s\s*-?\s*(750|950|1000)\b/gi, 'GSX-S $1')
      .replace(/\bgsxs\s*(750|950|1000)\b/gi, 'GSX-S $1')
      .replace(/\bsv\s*-?\s*650\b/gi, 'SV650')
      .replace(/\bv\s*-?\s*strom\s*(650|800|1000|1050)\b/gi, 'V-Strom $1')
      .replace(/\bpanigale\s*(v2|v4|899|959|1199|1299)\b/gi, function (match, model) {
        return 'Panigale ' + model.toUpperCase();
      })
      .replace(/\bstreetfighter\s*(v2|v4|848|1098)?\b/gi, function (match, model) {
        return model ? 'Streetfighter ' + model.toUpperCase() : 'Streetfighter';
      })
      .replace(/\brs\s*660\b/gi, 'RS 660')
      .replace(/\brsv\s*4\b/gi, 'RSV4')
      .replace(/\bsuper\s*duke\b|\bsuperduke\b/gi, 'Super Duke')
      .replace(/\brc\s*(390|790|890|990)\b/gi, 'RC $1')
      .replace(/\bstreet\s*triple\b/gi, 'Street Triple')
      .replace(/\bspeed\s*triple\b/gi, 'Speed Triple')
      .replace(/\broadglide\b/gi, 'Road Glide')
      .replace(/\broad\s*glide\b/gi, 'Road Glide')
      .replace(/\bstreetglide\b/gi, 'Street Glide')
      .replace(/\bstreet\s*glide\b/gi, 'Street Glide')
      .replace(/\broadking\b/gi, 'Road King')
      .replace(/\broad\s*king\b/gi, 'Road King')
      .replace(/\belectraglide\b/gi, 'Electra Glide')
      .replace(/\belectra\s*glide\b/gi, 'Electra Glide')
      .replace(/\blowrider\b/gi, 'Low Rider')
      .replace(/\blow\s*rider\b/gi, 'Low Rider')
      .replace(/\bfatboy\b/gi, 'Fat Boy')
      .replace(/\bfat\s*boy\b/gi, 'Fat Boy')
      .replace(/\bstreetbob\b/gi, 'Street Bob')
      .replace(/\bstreet\s*bob\b/gi, 'Street Bob')
      .replace(/\bpan\s*america\b/gi, 'Pan America');
  }

  function normalizeFuelCapAlias(value) {
    var text = compactSpaces(value);
    var key = text.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    var hasFuelCapIntent = /\b(?:gas|fuel)\b.*\b(?:cap|caps|tank|locking)\b|\b(?:tank|cap|caps|locking)\b.*\b(?:gas|fuel)\b|\btank cap\b|\bfuel cap\b|\bgas cap\b/.test(key);
    if (!hasFuelCapIntent) return text;

    var isKawasakiQuery = /\bkawasaki\b/.test(key);
    var isKawasaki636Query = /\b(?:zx\s*6r|zx6r|zx\s*636|zx636|636|ninja\s*zx\s*6r)\b/.test(key);
    if (isKawasakiQuery || isKawasaki636Query) return 'Kawasaki fuel tank locking cap';

    return text;
  }

  function normalizeCustomerSearch(value) {
    value = normalizeYamahaRAlias(compactSpaces(value));
    var exactPart = exactPartNumber(value);
    if (exactPart) return exactPart;
    var focused = compactSpaces(value)
      .replace(/\bshoei\s+helmets?\b/gi, 'shoei')
      .replace(/\bquadlock\b/gi, 'quad lock')
      .replace(/\bsp[\s-]*connect\b/gi, 'sp connect')
      .replace(/\bspc\s*\+\b/gi, 'spc+')
      .replace(/\bcnc[\s-]*racing\b/gi, 'cnc racing')
      .replace(/\bnew[\s-]*rage\b/gi, 'new rage cycles')
      .replace(/\bnrc\b/gi, 'new rage cycles')
      .replace(/\bakra\b/gi, 'akrapovic')
      .replace(/\bleo\s+vince\b/gi, 'leovince')
      .replace(/\bprocircuit\b/gi, 'pro circuit')
      .replace(/\bbiggun\b/gi, 'big gun')
      .replace(/\byoshi\b/gi, 'yoshimura')
      .replace(/\bbstwheels\b/gi, 'bst wheels')
      .replace(/\bscproject\b/gi, 'sc project')
      .replace(/\btermignioni\b/gi, 'termignoni')
      .replace(/\balpinestar\b/gi, 'alpinestars')
      .replace(/\bvance\s+(?:and|&)\s+hines\b/gi, 'vance hines')
      .replace(/\bphone\s+cover\b/gi, 'phone case')
      .replace(/\bcell\s+phone\b/gi, 'phone')
      .replace(/\btail\s+tidy\b/gi, 'fender eliminator')
      .replace(/\blicen[cs]e\s+plate\s+eliminator\b/gi, 'fender eliminator')
      .replace(/\bfender\s+delete\b/gi, 'fender eliminator')
      .replace(/\bbreak\s+(pads?|fluid|rotors?)\b/gi, 'brake $1')
      .replace(/\bcool(?:and|ent)\b/gi, 'coolant')
      .replace(/\bchain\s+lubricant\b/gi, 'chain lube')
      .replace(/\b(\d{1,2})\s*w\s*-?\s*(\d{2})\b/gi, '$1W-$2');

    focused = normalizePhoneAlias(focused);
    focused = normalizeTireSize(focused);
    focused = normalizeModelAlias(focused);
    focused = normalizeFuelCapAlias(focused);

    if (/\b\d{1,2}\s*w\s*-?\s*\d{2}\b/i.test(focused)) {
      focused = focused.replace(/\bmotor\s+oil\b/gi, 'oil');
    }

    focused = compactSpaces(focused);
    if (!focused) return focused;

    var normalized = focused.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    if (normalized === 'braking') return 'BRAKING search:braking';

    var isPhoneModel = /\b(?:iphone\s*(?:se|x|xr|xs|[5-9]|1[0-9])(?:\s*(?:pro\s*max|pro|max|plus|mini|air|e|s|c))?|galaxy\s*(?:s2[0-9]|a\d{2}|z\s*(?:fold|flip)\s*\d)|pixel\s*\d{1,2})\b/.test(normalized);
    var alreadySpecificPhoneIntent = /\b(?:case|cover|protector|poncho|mount|charger|charging|cable|adapter|adaptor|holder|lanyard)\b/.test(normalized);

    if (isPhoneModel && !alreadySpecificPhoneIntent) {
      if (/\biphone\s*(?:1[1-9]|[5-9])\b/.test(normalized) && !/\b(?:pro|max|air|plus|mini|se|x|xr|xs)\b/.test(normalized) && !/\biphone\s*(?:1[1-9]|[5-9])\s*e\b/.test(normalized)) {
        return focused.replace(/(iphone\s*(?:1[1-9]|[5-9]))\b/i, '$1*') + ' phone case';
      }
      return focused + ' phone case';
    }

    return focused;
  }

  function precisionSearchFields() {
    return 'title,vendor,product_type,tag,variants.sku';
  }

  function broadSearchFields() {
    return 'title,body,tag,product_type,vendor,variants.sku,variants.title';
  }

  function searchFields(options) {
    return options && options.broad ? broadSearchFields() : precisionSearchFields();
  }

  function normalizedKey(value) {
    return compactSpaces(value).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function detectIntent(value) {
    var key = normalizedKey(normalizeCustomerSearch(value));
    if (!key) return 'empty';
    if (isDealsQuery(key)) return 'deals';
    if (exactPartNumber(value)) return 'part-number';
    if (/\b(?:iphone|galaxy|pixel|samsung|phone case|quad lock|sp connect|spc)\b/.test(key)) return 'phone';
    if (/\b(?:tire|tyre|\d{2,3}\s+\d{2}\s+\d{2}|\d{2,3}\s*\/\s*\d{2,3}\s+\d{2})\b/.test(key)) return 'tire';
    if (/\b(?:exhaust|muffler|slip on|header|link pipe|baffle|akrapovic|leovince|arrow|vance hines|fmf|yoshimura)\b/.test(key)) return 'exhaust';
    if (/\b(?:fuel tank locking cap|fuel tank cap|gas cap|tank cap|fuel cap)\b/.test(key)) return 'accessories';
    if (/\b(?:oil|filter|brake|fluid|chain lube|coolant|cleaner|motul)\b/.test(key)) return 'maintenance';
    if (/\b(?:chain|sprocket|520|525|530|rk|vortex)\b/.test(key)) return 'drivetrain';
    if (/\b(?:helmet|jacket|glove|boot|hoodie|shirt|arai|hjc|sena)\b/.test(key)) return 'gear';
    if (/\b(?:yamaha|honda|kawasaki|suzuki|bmw|ducati|aprilia|ktm|triumph|harley|indian|yzf|crf|cbr|ninja|panigale|road glide)\b/.test(key) || key.split(' ').some(isVehicleModelToken)) return 'fitment';
    if (/\b(?:\d{4,}|[a-z]{1,4}[- ]?\d{3,})\b/.test(key)) return 'part-number';
    return 'general';
  }

  function isDealsQuery(value) {
    var key = normalizedKey(value);
    if (!key) return false;
    return /\b(?:deal|deals|promotion|promotions|promo|promos|discount|discounts|coupon|coupons|sale|sales|offer|offers|special|specials|reward|rewards|exhaust5|summer10|independence10)\b/.test(key);
  }

  function exactVendorGuard(value) {
    var key = normalizedKey(normalizeCustomerSearch(value));
    if (key === 'shoei') return 'Shoei';
    return '';
  }

  function uniqueList(values) {
    var seen = {};
    var out = [];
    values.forEach(function (value) {
      var clean = compactSpaces(value);
      var key = normalizedKey(clean);
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(clean);
    });
    return out;
  }

  function fallbackQueries(value) {
    var normalized = normalizeCustomerSearch(value);
    var key = normalizedKey(normalized);
    var fallbacks = [normalized];
    var intent = detectIntent(normalized);

    if (intent === 'phone' && !/\bphone case\b/i.test(normalized)) fallbacks.push(normalized + ' phone case');
    if (intent === 'exhaust' && /\bmuffler\b/i.test(normalized)) fallbacks.push(normalized.replace(/\bmuffler\b/gi, 'exhaust'));
    if (intent === 'exhaust' && /\bexhaust\b/i.test(normalized)) fallbacks.push(normalized.replace(/\bexhaust\b/gi, 'muffler'));
    if (intent === 'accessories' && /\bKawasaki fuel tank locking cap\b/i.test(normalized)) {
      fallbacks.push('Kawasaki fuel tank cap');
      fallbacks.push('Kawasaki gas cap');
      fallbacks.push('Rizoma Kawasaki fuel tank cap');
    }
    if (intent === 'maintenance' && /\bmotor oil\b/i.test(normalized)) fallbacks.push(normalized.replace(/\bmotor oil\b/gi, 'oil'));
    if (/\bfender eliminator\b/i.test(normalized)) fallbacks.push(normalized.replace(/\bfender eliminator\b/gi, 'tail tidy'));
    if (/\btail tidy\b/i.test(normalized)) fallbacks.push(normalized.replace(/\btail tidy\b/gi, 'fender eliminator'));
    if (/\bRoad Glide\b/i.test(normalized)) fallbacks.push(normalized.replace(/\bRoad Glide\b/gi, 'Touring'));
    if (/\bStreet Glide\b/i.test(normalized)) fallbacks.push(normalized.replace(/\bStreet Glide\b/gi, 'Touring'));
    if (/\bElectra Glide\b/i.test(normalized)) fallbacks.push(normalized.replace(/\bElectra Glide\b/gi, 'Touring'));
    if (/\bRoad King\b/i.test(normalized)) fallbacks.push(normalized.replace(/\bRoad King\b/gi, 'Dresser'));
    if (key.indexOf(' ') > -1) fallbacks.push(key.replace(/\s+/g, ' '));

    return uniqueList(fallbacks).slice(0, 6);
  }

  function buildSearchUrl(query, options) {
    if (isDealsQuery(query)) return new URL('/pages/deals', window.location.origin).toString();
    var url = new URL('/search', window.location.origin);
    var normalized = normalizeCustomerSearch(query);
    url.searchParams.set('q', normalized);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    var broad = Boolean(options && options.broad);
    url.searchParams.set('options[fields]', searchFields({ broad: broad }));
    if (broad) url.searchParams.set('p4m_broad', '1');
    if (options && options.retry) url.searchParams.set('p4m_retry', String(options.retry));
    if (options && options.source) url.searchParams.set('p4m_source', options.source);
    return url.toString();
  }

  function productCategoryExpression(category) {
    // These are the existing selector's keyword families, not verified fitment
    // or a claim that product_type has been curated for every catalog item.
    var terms = compactSpaces(category).match(/[a-z0-9-]+/gi) || [];
    return terms.length ? '(' + terms.join(' OR ') + ')' : '';
  }

  function productQuery(keyword, category) {
    var focused = normalizeCustomerSearch(keyword);
    var categoryExpression = productCategoryExpression(category);
    if (!categoryExpression) return focused;
    return focused ? '(' + focused + ') AND ' + categoryExpression : categoryExpression;
  }

  function productKeyword(query, category) {
    var source = compactSpaces(query);
    var categoryText = compactSpaces(category);
    var expression = productCategoryExpression(categoryText);
    if (!expression) return source;
    if (source === expression) return '';
    var structuredSuffix = ') AND ' + expression;
    if (source.charAt(0) === '(' && source.slice(-structuredSuffix.length) === structuredSuffix) {
      return source.slice(1, -structuredSuffix.length);
    }
    // Back/refresh of a legacy URL must not append the keyword bundle twice.
    if (source.toLowerCase() === categoryText.toLowerCase()) return '';
    var legacySuffix = ' ' + categoryText;
    if (source.toLowerCase().slice(-legacySuffix.length) === legacySuffix.toLowerCase()) {
      return source.slice(0, -legacySuffix.length).trim();
    }
    return source;
  }

  function trackSearch(payload) {
    var detail = payload || {};
    detail.normalized = detail.normalized || normalizeCustomerSearch(detail.query || '');
    detail.intent = detail.intent || detectIntent(detail.normalized);
    detail.version = '2026-08-02.search-precision-2';

    window.dispatchEvent(new CustomEvent('p4m:search', { detail: detail }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'p4m_search',
      p4m_search_query: detail.query || '',
      p4m_search_normalized: detail.normalized || '',
      p4m_search_intent: detail.intent || '',
      p4m_search_source: detail.source || '',
      p4m_search_results: typeof detail.results === 'number' ? detail.results : undefined,
      p4m_search_mode: detail.mode === 'broad' ? 'broad_fallback' : 'precision'
    });
  }

  window.P4MSearch = window.P4MSearch || {};
  window.P4MSearch.version = '2026-08-02.search-precision-2';
  window.P4MSearch.searchFields = searchFields;
  window.P4MSearch.precisionSearchFields = precisionSearchFields;
  window.P4MSearch.broadSearchFields = broadSearchFields;
  window.P4MSearch.normalize = normalizeCustomerSearch;
  window.P4MSearch.intent = detectIntent;
  window.P4MSearch.isDealsQuery = isDealsQuery;
  window.P4MSearch.exactVendorGuard = exactVendorGuard;
  window.P4MSearch.dealsUrl = '/pages/deals';
  window.P4MSearch.fallbackQueries = fallbackQueries;
  window.P4MSearch.buildSearchUrl = buildSearchUrl;
  window.P4MSearch.productQuery = productQuery;
  window.P4MSearch.productKeyword = productKeyword;
  window.P4MSearch.intentVersion = '2026-09-15.compound-context-1';
  window.P4MSearch.track = trackSearch;
})();
